import React, { useState } from 'react';
import { CustomerCareHomePage, PhoneIntakeModule, LeadIntakeModule, PhoneIntakeArchive } from './CustomerCareGear';
import SOPsModule from '../components/customercare/SOPsModule';
import { CustomLeadFormsModule } from '../components/customercare/CustomLeadFormsModule';

const CustomerCareGearPage = ({ currentUser, onBackToGears }) => {
  const [currentPage, setCurrentPage] = useState('home');
  const [currentPhoneIntake, setCurrentPhoneIntake] = useState(null);
  const [phoneIntakeReturnPage, setPhoneIntakeReturnPage] = useState('home');

  switch (currentPage) {
    case 'home':
      return (
        <CustomerCareHomePage
          onNavigate={setCurrentPage}
          onBackToGears={onBackToGears}
          currentUser={currentUser}
        />
      );
    case 'phone-intake':
      return (
        <PhoneIntakeModule
          onBack={() => setCurrentPage(phoneIntakeReturnPage)}
          currentUser={currentUser}
          initialIntake={currentPhoneIntake}
        />
      );
    case 'lead-intake':
      return (
        <LeadIntakeModule
          onBack={() => setCurrentPage('home')}
          currentUser={currentUser}
          initialIntake={currentPhoneIntake}
        />
      );
    case 'phone-intake-archive':
      return (
        <PhoneIntakeArchive
          onBack={() => setCurrentPage('home')}
          onOpenIntake={(item) => {
            setCurrentPhoneIntake(item);
            setPhoneIntakeReturnPage('phone-intake-archive');
            setCurrentPage('phone-intake');
          }}
        />
      );
    case 'custom-lead-forms':
      return (
        <CustomLeadFormsModule
          onBack={() => setCurrentPage('home')}
          currentUser={currentUser}
        />
      );
    case 'sops':
      return (
        <SOPsModule
          onBack={() => setCurrentPage('home')}
          currentUser={currentUser}
        />
      );
    default:
      return (
        <CustomerCareHomePage
          onNavigate={setCurrentPage}
          onBackToGears={onBackToGears}
          currentUser={currentUser}
        />
      );
  }
};

export default CustomerCareGearPage;
